import AOS from 'aos';

/**
 * Scroll reveal animations (AOS).
 * Elements opt in via `data-aos="fade-up|fade-left|fade-right|zoom-in|..."`.
 * Disabled automatically when the user prefers reduced motion.
 */
export function reveal() {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  AOS.init({
    once: true,
    duration: 700,
    easing: 'ease-out-cubic',
    offset: 80,
    disable: reduced,
  });

  // Recalculate positions once late-loading (lazy) images settle the layout.
  setTimeout(() => AOS.refresh(), 500);
}
